import { Navigate as RRDNavigate, useParams } from "react-router-dom";
import React from "react";

const NavigateWithParams = (props) => {
  const params = useParams();
  const path = () => {
    let resolvedPath = props.to;
    for (const [key, value] of Object.entries(params)) {
      resolvedPath = resolvedPath.replace(`:${key}`, value);
    }

    return resolvedPath;
  };
  return <RRDNavigate {...props} to={path()} />;
};

const Navigate = (props) => {
  if (!props.to.includes(":")) return <RRDNavigate {...props} />;
  return <NavigateWithParams {...props} />;
};

export default Navigate;
